import { from, race, Subject } from "rxjs";
import { timeout } from "rxjs/operators";

async function testAliasConnection(connection, location, timeoutSeconds) {
  return await connection.invoke(
    "TestAliasConnection",
    location,
    timeoutSeconds
  );
}

async function testAliasDtoConnection(connection, location, timeoutSeconds) {
  return await connection.invoke(
    "TestAliasDtoConnection",
    location,
    timeoutSeconds
  );
}

export class LocationTester {
  constructor(connection) {
    this.cancelation = null;
    this.connection = connection;
  }

  testAliasConnection(location, timeoutSeconds = 30) {
    this.cancelation = new Subject();
    return race(
      from(testAliasConnection(this.connection, location, timeoutSeconds)),
      this.cancelation.asObservable()
    )
      .pipe(timeout(timeoutSeconds * 1000))
      .toPromise();
  }

  testAliasDtoConnection(location, timeoutSeconds = 30) {
    this.cancelation = new Subject();
    return race(
      from(testAliasDtoConnection(this.connection, location, timeoutSeconds)),
      this.cancelation.asObservable()
    )
      .pipe(timeout(timeoutSeconds * 1000))
      .toPromise();
  }

  cancelTest(msg = "Test canceled.") {
    this.cancelation?.error(msg);
  }
}
